// The one Job Card PDF download (GET /engagements/{id}/card/report.pdf) — used by the Job Card's
// Download button, the stage collapsibles' download button and SAM's get_job_card(download=true)
// (DOWNLOAD_ENGAGEMENT_JOB_CARD), so they always fetch, name and save the file the same way.
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyGetJobCardPdfQuery } from '@/redux/internal-services/jobsApi';

export function useDownloadJobCardPdf(engagementId: string | undefined) {
  const { t } = useTranslation();
  const [fetchPdf, { isFetching: downloading }] = useLazyGetJobCardPdfQuery();
  const [error, setError] = useState('');

  const download = useCallback(async () => {
    if (!engagementId) return;
    setError('');
    try {
      const blob = await fetchPdf(engagementId).unwrap();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `job-card-${engagementId}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch {
      setError(t('jobs.downloadFailed', 'Could not download the Job Card report.'));
    }
  }, [engagementId, fetchPdf, t]);

  return { download, downloading, error };
}
